import { ActivatedRouteSnapshot } from '@angular/router';

import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { firstValueFrom } from 'rxjs';

import { DetailedEventViewModel } from '../event-details-common/event-details-common.models';
import { EventDetailsViewModelFetcher } from './event-details-view-model-fetcher.service';
import { NavigationLayoutService } from './navigation-layout.service';

export abstract class BaseEventDetailsResolver {
    constructor(
        protected navLayoutService: NavigationLayoutService,
        protected eventDetailsViewModelResolver: EventDetailsViewModelFetcher,
        protected sitecoreEventDetails: SitecoreEventDetailsConfig,
    ) {}

    async resolve(route: ActivatedRouteSnapshot): Promise<DetailedEventViewModel> {
        const result = await this.baseResolve(route);

        if (result.model) {
            this.navLayoutService.register(result.model);
        } else {
            this.navLayoutService.unregister();
        }

        return result;
    }

    async baseResolve(route: ActivatedRouteSnapshot): Promise<DetailedEventViewModel> {
        const [result] = await Promise.all([
            this.eventDetailsViewModelResolver.resolve(route).then((vm) => this.extendViewModel(route, vm)),
            this.loadStyles(),
            firstValueFrom(this.sitecoreEventDetails.whenReady),
        ]);
        return result;
    }

    abstract loadStyles(): Promise<void>;

    abstract extendViewModel(route: ActivatedRouteSnapshot, detailedViewModel: DetailedEventViewModel): Promise<DetailedEventViewModel>;
}
